import React, { useContext, useEffect } from 'react';
import { useState, useRef } from 'react';
import { Container, Tab, Tabs, Table, Button, Card, ListGroup } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { BsBasketFill } from "react-icons/bs";
import { FaPlus } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import ProductCarousel from './ProductCarousel';
import ProductCarouselSep from './ProductCarouselSep';
import ImageZoom from './ImageZoom';
import "./Product.css";
import imgNotFound from '../img/img_not_found.jpg'
import Load from './Load';
import { GetUserContext } from '../Context/GetUserContext';
import formats from '../controller/views/formats'
import aplications from '../controller/api/Aplications';
import products from '../controller/api/Product';
import { TiDelete } from "react-icons/ti";
import { FaMinus } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";


const ProductCar = ({ idUser, product, allItens }) => {
    const { size, fetchTimestampApp, setFetchTimestampApp, qtdCar, setQtdCar, axiosConfig, qtdTotal, setqtdTotal } = useContext(GetUserContext);
    const [aplication, setAplication] = useState({});
    const Aplications = new aplications();
    const Produto = new products();
    const [crossProduct, setcrossProduct] = useState([]);
    const [loadCross, setLoadCorss] = useState();
    const [indexImg, setIndexImg] = useState(0);
    const [habilityMoreQtd, setHabilityMoreQtd] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const handleCloseAlert = () => setShowAlert(false);
    console.log(product);
    const [showF, setShowF] = useState(false);
    const handleClose = () => setShowF(false);
    const [verifyAplication, setVerifyAplication] = useState(false)

    const handleShowF = () => {
        setShowF(true);

        Aplications.getAplications(product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.id)
            .then(response => {
                if (response?.vehicles == undefined) {
                    setVerifyAplication(true)

                } else {
                    setVerifyAplication(false)
                    setAplication(response)
                }
            })
    };

    const produtosSimilaresRef = useRef(null);
    const handleCloseSimilar = () => {
        if (produtosSimilaresRef.current) {
            produtosSimilaresRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [isZoomVisible, setIsZoomVisible] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ backgroundPosition: '0% 0%' });
    const handleMouseEnter = () => setIsZoomVisible(true);
    const handleMouseLeave = () => setIsZoomVisible(false);

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.target.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        setZoomPosition({ backgroundPosition: `${x}% ${y}%` });
    };

    const changeFoto = (e) => {
        setIndexImg(e)
    }

    const handleRemoveProdCart = (e) => {
        e.preventDefault();
        const newValorTotal = (parseFloat(qtdTotal) - (allItens?.Qtd_Produto * parseFloat(allItens?.Valor))).toFixed(2);
        const storedItems = JSON.parse(localStorage.getItem(`itemCardProd${idUser}`)) || [];
        const newProducCarAfterRemove = storedItems.filter(produto => produto.ID_Produto_Estoque !== allItens.ID_Produto_Estoque);
        localStorage.setItem(`itemCardProd${idUser}`, JSON.stringify(newProducCarAfterRemove));
        localStorage.setItem('qtnTotalCar', newValorTotal);

        setqtdTotal(newValorTotal);
        setFetchTimestampApp(Date.now());
    };

    const [qtdProduto, setQtdProduto] = useState(parseInt(allItens.Estoque_Carrinho)); // Inicializa com a quantidade atual do item
    const storedItems = JSON.parse(localStorage.getItem(`itemCardProd${idUser}`)) || [];

    const handleAddQtd = () => {
        const currentQtd = parseInt(allItens?.product?.Produtos_Estoques?.[0]?.Qtd_Estoque)
        if (allItens?.product?.id === product?.id) {
            setQtdProduto(prevQtd => {
                if (prevQtd < currentQtd) {
                    return prevQtd + 1;
                }
                return prevQtd;
            });
        }

        if (qtdProduto >= currentQtd) {
            setShowAlert(true)
        }
    };

    const handleMinusQtd = () => {
        setQtdProduto(prevQtd => (prevQtd > 1 ? prevQtd - 1 : 1));
    };
    useEffect(() => {
        const prodQtd = storedItems.map(prod =>
            prod.ID_Produto_Estoque === allItens.ID_Produto_Estoque ? { ...prod, Estoque_Carrinho: qtdProduto, ValorQtd: (qtdProduto * parseFloat(prod.Preco_Produto)) } : prod
        );
        localStorage.setItem(`itemCardProd${idUser}`, JSON.stringify(prodQtd));
        setFetchTimestampApp(Date.now());
    }, [qtdProduto]);
    useEffect(() => {
        setqtdTotal(parseInt(localStorage.getItem('qtnTotalCar')) || 0)
    }, [qtdTotal, setqtdTotal])

    useEffect(() => {
        if (qtdProduto >= allItens?.Qtd_Produto) {
            setHabilityMoreQtd(true)

        }
        return setHabilityMoreQtd(false)
    }, [allItens, qtdProduto])


    const [activeKey, setActiveKey] = useState("0");

    const isActive = (key) => activeKey === key;

    return (
        <>
            <Card className='product-car'>
                <div onClick={handleRemoveProdCart} className='icone-delete'><TiDelete /> </div>
                <Card.Header className='photo-product' onClick={() => handleShowF(true)}>
                    {
                        product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[0]?.thumbnailUrl == undefined ?
                            (<img src={imgNotFound} />) :
                            (<img src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0].product?.images[0]?.thumbnailUrl} />)
                    }
                </Card.Header>
                <Card.Body className='area-description-product' onClick={() => handleShowF(true)}>
                    <div className='title-product'>{product?.Nome_Produto}</div>
                    <div className='text-product'>Referência: <strong>{product?.Referencia_Produto}</strong></div>
                    <div className='text-product'>Em Estoque: <strong>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong></div>
                </Card.Body>
                <Card.Footer >

                    <div className='area-add-car'>
                        <button onClick={handleAddQtd} className='btn'> <FaPlus /></button>
                        <div className='qtd-prod-car'>{parseInt(allItens?.Estoque_Carrinho)}</div>
                        <button onClick={handleMinusQtd} className='btn'> <FaMinus /></button>
                    </div>

                    <div className='icon-add-car-market-car'> <strong>R$ </strong> <strong> {formats.formatPrice(allItens?.Preco_Produto)}</strong></div>
                </Card.Footer>
            </Card>

            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <Modal show={showF} onHide={handleClose}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            fullscreen
                        >
                            <Modal.Header className='container' closeButton>
                                <h5>{product?.Nome_Produto}</h5>
                            </Modal.Header>

                            <Modal.Body className='container max-width-modal-product'  >
                                <div>
                                    <div className='area-fullscreen-product-image-mobile'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images == null ?
                                                (<img src={imgNotFound} />) :
                                                (<img className='img-full' src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl} />)
                                        }
                                    </div>

                                    <div className='area-photo-small-mobile'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.map((img, index) => (
                                                <React.Fragment key={index}>
                                                    <div onMouseOver={(e) => { changeFoto(index) }}><img src={img?.thumbnailUrl} /></div>
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                    <br></br>

                                    {
                                        isZoomVisible && product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[0]?.imageUrl != undefined ?
                                            (<div className='area-fullscreen-product-image-zoom'>
                                                <div className='zoom-area'
                                                    style={{
                                                        backgroundImage: `url('${product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl}')`,
                                                        ...zoomPosition,
                                                    }}
                                                >
                                                </div>
                                            </div>) :
                                            (<div className='area-fullscreen-product-mobile'>
                                                <hr></hr>
                                                <br></br>
                                                <h1 className='price-mobile'>R$ {formats.formatPrice(product?.Preco_4)}</h1>
                                                <div>Vendido por: <strong className='text-secondary'>Auparts Distribuidora</strong></div>
                                                <div>Referência: <strong className='text-secondary'>{product?.Referencia_Produto}</strong> </div>
                                                <div>Fabricante: <strong className='text-secondary'>{product?.Fabricante?.Nome_Fabricante}</strong> </div>
                                                <div>Estoque: <strong className='text-secondary'>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong></div>
                                                <br></br>


                                                <div className='d-flex'>
                                                    <Button variant='success'>No Carrinho</Button>

                                                    <div className='area-add-car'>
                                                        <button onClick={handleAddQtd} className='btn'> <FaPlus /></button>
                                                        <div className='qtd-prod-car'><span style={{ fontSize: ".8em" }}>{allItens.Estoque_Carrinho}</span></div>
                                                        <button onClick={handleMinusQtd} className='btn'> <FaMinus /></button>
                                                    </div>

                                                </div>
                                                <br></br>

                                            </div>)
                                    }
                                </div>
                                <hr></hr>
                                {
                                    verifyAplication ?
                                        (<Tabs
                                            defaultActiveKey="Aplicação"
                                            id="uncontrolled-tab-example"
                                            className="mb-3"
                                        >
                                            <Tab eventKey="Aplicação" title="Descrição">
                                                <div className='area-aplication-product' >
                                                    <Table striped>
                                                        <thead className='table-header'>
                                                            <tr> </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-cell-loading">{product?.Descricao_Auri}</td>
                                                            </tr>
                                                        </tbody>

                                                    </Table>
                                                </div>
                                            </Tab>
                                        </Tabs>)
                                        :
                                        (
                                            <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header className={isActive("0") ? "active-acordeon" : ""}>
                                                        Aplicação
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom' >
                                                        {
                                                            aplication?.vehicles === undefined ? (
                                                                <div className="table-cell-loading">Carregando...</div>
                                                            ) : (
                                                                aplication?.vehicles
                                                                    ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                                                                    ?.map((app, index) => (
                                                                        <div style={{ fontSize: ".8em" }} className='text-secondary form-control mb-2' key={index}>
                                                                            <span>{app?.brand}  </span>
                                                                            <span>{app?.name}  </span>
                                                                            <span>{app?.model}  </span>
                                                                            <span>{app?.engineName}  </span>
                                                                            <span>{app?.engineConfiguration}  </span>
                                                                            <span>{app?.startYear} - </span>
                                                                            <span>{app?.endYear}</span>

                                                                        </div>
                                                                    ))
                                                            )
                                                        }

                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header className={isActive("1") ? "active-acordeon" : ""}>
                                                        Ficha Técnica
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom'>
                                                        {
                                                            aplication?.specifications?.map((spec, index) => (
                                                                <ListGroup key={index}>
                                                                    <ListGroup.Item className='mb-1' > {`${spec?.description}: `}<strong className='text-secondary'>{spec?.value}</strong></ListGroup.Item>
                                                                </ListGroup>


                                                            ))
                                                        }

                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="2">
                                                    <Accordion.Header className={isActive("2") ? "active-acordeon" : ""}>
                                                        Referência Cruzada
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom'>
                                                        <div className='similar-product-fullscreen'>
                                                            {
                                                                loadCross ?
                                                                    (<>Carregando...</>)
                                                                    : (<>

                                                                        <Table striped>
                                                                            <thead className='table-header'>
                                                                                <tr>
                                                                                    <th>Montadora</th>
                                                                                    <th>Código</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {

                                                                                    aplication?.crossReference?.length == 0 ?
                                                                                        (<tr>
                                                                                            <td className="table-cell-loading">Carregando...</td>
                                                                                        </tr>
                                                                                        ) :
                                                                                        (
                                                                                            aplication?.crossReference?.map((app, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>{app?.brand?.name}</td>
                                                                                                    <td className='text-right'>{app?.partNumber}</td>

                                                                                                </tr>
                                                                                            ))
                                                                                        )
                                                                                }

                                                                            </tbody>
                                                                        </Table>

                                                                    </>)

                                                            }

                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        )
                                }
                                <br></br>
                                <hr></hr>
                            </Modal.Body>
                        </Modal >)
                    :
                    (
                        <Modal show={showF} onHide={handleClose}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className="custom-width-modal"
                        >
                            <Modal.Header className='container' closeButton>
                                <Modal.Title>{product?.Nome_Produto}</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className='container max-width-modal-product'  >
                                <div className='d-flex justify-content-between border' >

                                    <div className='area-photo-small'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.map((img, index) => (
                                                <React.Fragment key={index}>
                                                    <div onMouseOver={(e) => { changeFoto(index) }}><img src={img?.thumbnailUrl} /></div>
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>

                                    <div
                                        className='area-fullscreen-product-image'
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        onMouseMove={handleMouseMove}
                                    >
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images == null ?
                                                (<img src={imgNotFound} />) :
                                                (<img src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl} width={550} />)
                                        }
                                    </div>

                                    {
                                        isZoomVisible && product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[0]?.imageUrl != undefined ?
                                            (<div className='area-fullscreen-product-image-zoom'>

                                                <div
                                                    className='zoom-area'
                                                    style={{
                                                        backgroundImage: `url('${product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl}')`,
                                                        ...zoomPosition,
                                                    }}
                                                ></div>
                                            </div>) :
                                            (<div className='area-fullscreen-product'>
                                                <br></br>
                                                <br></br>
                                                <div>Vendido por: <strong className='text-secondary'>Auparts Distribuidora</strong></div>
                                                <div>Referência: <strong className='text-secondary'>{product?.Referencia_Produto}</strong> </div>
                                                <div>Fabricante: <strong className='text-secondary'>{product?.Fabricante?.Nome_Fabricante}</strong> </div>
                                                <div>Estoque: <strong className='text-secondary'>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong></div>
                                                <br></br>

                                                <h1>R$ {formats.formatPrice(allItens?.Preco_Produto)}</h1>
                                                <div className='d-flex'>
                                                    <Button size="lg" variant='warning'>Comprar</Button>

                                                    <div className='area-add-car'>
                                                        <button onClick={handleAddQtd} className='btn'> <FaPlus /></button>
                                                        <div className='qtd-prod-car'><span style={{ fontSize: ".8em" }}>{allItens.Estoque_Carrinho}</span></div>
                                                        <button onClick={handleMinusQtd} className='btn'> <FaMinus /></button>
                                                    </div>

                                                </div>
                                                <br></br>

                                                <div onClick={handleCloseSimilar} className='similar-product-fullscreen'>
                                                    {
                                                        loadCross ?
                                                            (<>Carregando...</>)
                                                            : (<>
                                                                {
                                                                    crossProduct?.map((productCross, index) => (

                                                                        <div key={index}>
                                                                            <div className='similar-product-little'>
                                                                                {
                                                                                    productCross?.Fotos?.[0]?.Url == undefined ?
                                                                                        (<img src={imgNotFound} />) :
                                                                                        (<img src={productCross?.Fotos[0]?.Url} />)
                                                                                }
                                                                            </div>

                                                                            <strong style={{ fontSize: ".65em" }}>R$ {formats.formatPrice(productCross?.Preco_4)}</strong>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </>)

                                                    }

                                                </div>
                                            </div>)
                                    }
                                </div>
                                <br></br>
                                <Container>
                                    {
                                        verifyAplication ?
                                            (<Tabs
                                                defaultActiveKey="Aplicação"
                                                id="uncontrolled-tab-example"
                                                className="mb-3"
                                            >
                                                <Tab eventKey="Aplicação" title="Descrição">
                                                    <div className='area-aplication-product' >
                                                        <Table striped>
                                                            <thead className='table-header'>
                                                                <tr> </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-cell-loading">{product?.Descricao_Auri}</td>
                                                                </tr>
                                                            </tbody>

                                                        </Table>
                                                    </div>
                                                </Tab>
                                            </Tabs>)
                                            :
                                            (
                                                <Tabs
                                                    defaultActiveKey="Aplicação"
                                                    id="uncontrolled-tab-example"
                                                    className="mb-3"
                                                >
                                                    <Tab eventKey="Aplicação" title="Aplicação">
                                                        <div className='area-aplication-product' >
                                                            <Table striped>
                                                                <thead className='table-header'>
                                                                    <tr>
                                                                        <th>Montadora</th>
                                                                        <th>Veiculo</th>
                                                                        <th>Modelo</th>
                                                                        <th>Motor</th>
                                                                        <th>Config. Motor</th>
                                                                        <th>Ano Inicial</th>
                                                                        <th>Ano Final</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        aplication?.vehicles === undefined ? (
                                                                            <tr>
                                                                                <td className="table-cell-loading">Carregando...</td>
                                                                            </tr>
                                                                        ) : (
                                                                            aplication?.vehicles
                                                                                ?.sort((a, b) => a?.name?.localeCompare(b?.name)) // Ordena alfabeticamente pelo campo "name"
                                                                                ?.map((app, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>{app?.brand}</td>
                                                                                        <td>{app?.name}</td>
                                                                                        <td>{app?.model}</td>
                                                                                        <td>{app?.engineName}</td>
                                                                                        <td>{app?.engineConfiguration}</td>
                                                                                        <td>{app?.startYear}</td>
                                                                                        <td>{app?.endYear}</td>
                                                                                    </tr>
                                                                                ))
                                                                        )
                                                                    }
                                                                </tbody>

                                                            </Table>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="Detalhes" title="Ficha Técnica">
                                                        <div className='area-aplication-product' >

                                                            <h6>Especificações Técnicas</h6>

                                                            {
                                                                aplication?.specifications?.map((spec, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <div className='form-control'> {`${spec?.description}: `}<strong className='text-secondary'>{spec?.value}</strong></div>

                                                                    </React.Fragment>

                                                                ))
                                                            }


                                                        </div>
                                                    </Tab>

                                                    <Tab eventKey="Referencia Cruzada" title="Referência Cruzada">
                                                        <Card ref={produtosSimilaresRef} className='border-0'>
                                                            <Card.Body>

                                                                <div className='similar-product-fullscreen'>
                                                                    {


                                                                        loadCross ?
                                                                            (<>CarregandoWWW...</>)
                                                                            : (<>

                                                                                <Table striped>
                                                                                    <thead className='table-header'>
                                                                                        <tr>
                                                                                            <th>Montadora</th>
                                                                                            <th>Veiculo</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {

                                                                                            aplication?.crossReference?.length == 0 ?
                                                                                                (<tr>
                                                                                                    <td className="table-cell-loading">Carregando...</td>
                                                                                                </tr>
                                                                                                ) :
                                                                                                (
                                                                                                    aplication?.crossReference?.map((app, index) => (
                                                                                                        <tr key={index}>
                                                                                                            <td>{app?.brand?.name}</td>
                                                                                                            <td>{app?.partNumber}</td>

                                                                                                        </tr>
                                                                                                    ))
                                                                                                )
                                                                                        }

                                                                                    </tbody>
                                                                                </Table>

                                                                            </>)

                                                                    }

                                                                </div>

                                                            </Card.Body>
                                                        </Card>
                                                    </Tab>
                                                </Tabs>
                                            )
                                    }
                                </Container>
                            </Modal.Body>
                        </Modal >
                    )
            }



            <Modal show={showAlert} onHide={handleCloseAlert}>
                <Modal.Body> A quantidade adicionada não pode exceder o estoque disponível.</Modal.Body>
            </Modal>
        </>
    )
}

export default ProductCar